module.exports = __webpack_public_path__ + "img/Correct.ced1e386.png";